import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'services/http.service';
import {
  VacationBalanceDistributionDetailModel,
  VacationIndicatorsModel,
  VacationLimitConcentrationDetailModel,
  VacationMonthlyConcentrationDetailModel,
  VacationMetricsParams,
} from 'services/models/corporate/vacation-indicators.model';

@Injectable()
export class VacationScheduleMetricsService {
  private readonly endpoint = 'VacationSchedule';

  constructor(private http: HttpService) {}

  getMetrics(filters: VacationMetricsParams | null = null): Observable<VacationIndicatorsModel> {
    return this.http
      .get(`${this.endpoint}/metrics`, { params: this._buildParams(filters) }, undefined, undefined, true)
      .pipe(map((res: { body: VacationIndicatorsModel }) => res.body));
  }

  getLimitConcentrationDetails(
    reference: string,
    filters: VacationMetricsParams | null = null
  ): Observable<VacationLimitConcentrationDetailModel> {
    let params = this._buildParams(filters);
    params = params.set('reference', reference);

    return this.http
      .get(`${this.endpoint}/metrics/limit-concentration/details`, { params }, undefined, undefined, true)
      .pipe(map((res: { body: VacationLimitConcentrationDetailModel }) => res.body));
  }

  getBalanceDistributionDetails(
    rangeKey: string,
    filters: VacationMetricsParams | null = null
  ): Observable<VacationBalanceDistributionDetailModel> {
    let params = this._buildParams(filters);
    params = params.set('rangeKey', rangeKey);

    return this.http
      .get(`${this.endpoint}/metrics/balance-distribution/details`, { params }, undefined, undefined, true)
      .pipe(map((res: { body: VacationBalanceDistributionDetailModel }) => res.body));
  }

  getMonthlyConcentrationDetails(
    reference: string,
    filters: VacationMetricsParams | null = null
  ): Observable<VacationMonthlyConcentrationDetailModel> {
    let params = this._buildParams(filters);
    params = params.set('reference', reference);

    return this.http
      .get(`${this.endpoint}/metrics/monthly-concentration/details`, { params }, undefined, undefined, true)
      .pipe(map((res: { body: VacationMonthlyConcentrationDetailModel }) => res.body));
  }

  private _buildParams(filters: VacationMetricsParams | null = null): HttpParams {
    let params = new HttpParams();

    if (!filters) {
      return params;
    }

    Object.entries(filters).forEach(([key, value]: [string, unknown]) => {
      if (value === null || value === undefined || value === '') {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach(item => {
          if (item !== null && item !== undefined && item !== '') {
            const paramKey = key === 'costCenterIds' ? 'CostCenterIds' : 'TimeShiftIds';
            params = params.append(paramKey, item as string);
          }
        });
        return;
      }

      if (typeof value === 'boolean') {
        params = params.set(key, value ? 'true' : 'false');
        return;
      }

      const paramKey = key === 'companyId'
        ? 'companyId'
        : key === 'companyRootId'
          ? 'companyRootId'
          : key;

      params = params.set(paramKey, value as string);
    });

    return params;
  }
}
